import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable no-console */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var ErrorBoundary = /*#__PURE__*/function (_PureComponent) {
  _inherits(ErrorBoundary, _PureComponent);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var onError = this.props.onError; // Display fallback UI

      this.setState({
        hasError: true
      }); // You can also log the error to an error reporting service

      console.error(error, info);
      onError();
    }
  }, {
    key: "render",
    value: function render() {
      var hasError = this.state.hasError,
          _this$props = this.props,
          children = _this$props.children,
          _this$props$errorTips = _this$props.errorTips,
          errorTips = _this$props$errorTips === void 0 ? /*#__PURE__*/React.createElement("div", null) : _this$props$errorTips;

      if (hasError) {
        // You can render any custom fallback UI
        return {
          errorTips: errorTips
        };
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(PureComponent);

export { ErrorBoundary as default };
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  onError: PropTypes.func,
  errorTips: PropTypes.node
};
ErrorBoundary.defaultProps = {
  children: null,
  errorTips: null,
  onError: function onError() {}
};